import { MainWebsiteEvents } from "@glamcorner/gc-types/generated/ipcBusEvents";
import { GcSessionInfo } from "@glamcorner/gc-types/generated/types";

export type FavouriteStyleResponseType = {
  name: string;
  price: string;
  productId: string;
  qty: string;
  styleCode: string;
};

export class Favourites {
  private isLoggedIn: boolean = false;
  public _productIds: any;

  constructor() {
    this._productIds = {};

    GlamCornerCore.bus.on("hearts.set", {}, (data: any) => {
      this.addProductId(data.product.id);
    });

    GlamCornerCore.bus.on("hearts.unset", {}, (data: any) => {
      this.removeProductId(data.product.id);
    });

    const fetchFavourites = () => {
      if (Favourites.isFavouritesPage() && this.isLoggedIn) {
        this.loadFromServer();
      }
    };

    GlamCornerCore.bus.on(MainWebsiteEvents.GcSessionXhrFinished, {}, (gcSessionInfo: GcSessionInfo) => {
      this.isLoggedIn = gcSessionInfo.loggedIn;
      fetchFavourites();
    });

    GlamCornerCore.bus.on(MainWebsiteEvents.CatalogueLoaded, {}, () => {
      fetchFavourites();
    });
  }

  private apply() {
    // Find all products and set a active class on hearts which we have stored
    const productElements = document.querySelectorAll("[data-product]");
    if (productElements) {
      productElements.forEach((element) => {
        const dataProductAttribute = element.getAttribute("data-product");
        if (dataProductAttribute === null) {
          return;
        }

        let productData;
        try {
          productData = JSON.parse(dataProductAttribute);
        } catch (e) {
          return;
        }
        const { id, style } = productData;

        const heartElement = document.querySelector(`[data-sku='${style}'] .js-heart`);
        if (heartElement === null) {
          return;
        }

        if (Object.keys(this._productIds).indexOf(`${id}`) > -1) {
          heartElement.classList.add("active");
        } else {
          heartElement.classList.remove("active");
        }
      });
    }
  }

  private addProductId(productId: any) {
    this._productIds[Number(productId)] = true;

    this.postAction("add", productId);
  }

  private removeProductId(productId: any) {
    delete this._productIds[Number(productId)];

    this.postAction("remove", productId);
  }

  private setIds(productIds: any) {
    this._productIds = {};
    for (let i = 0; i < productIds.length; i++) {
      this._productIds[Number(productIds[i])] = true;
    }
  }

  private async loadFromServer() {
    const response = await fetch("/wishlist/index/json");
    const data = (await response.json()) as FavouriteStyleResponseType[];

    const ids = data.map((data: any) => data.productId);
    this.setIds(ids);
    this.apply();
  }

  private static isFavouritesPage() {
    // is a favourites page if it has at least one product on it.
    return !!document.querySelector("[data-product]");
  }

  private async postAction(action: any, productId: any) {
    const url = `/wishlist/index/${action}/product/${productId}`;
    await fetch(url, { method: "POST" });
  }
}
